import React from 'react';
import { Route } from 'react-router';
import { Redirect, Switch } from 'react-router-dom';

// Routes
import AllCandidates from './routes/all-candidates';
import SingleCandidates from './routes/single-candidates';

export default function () {
    return(
        <div>
            <Switch>
                <Route exact path='/candidates/all' component={() => <AllCandidates />} />
                <Route exact path='/candidates/:id' component={() => <SingleCandidates />} />
                <Route exact path='/candidates' component={() => <Redirect to={`/candidates/all`} />} />
            </Switch>
        </div>
    )
}